module.exports = __webpack_public_path__ + "img/crosschain.df4fcf61.png";